<div class="wrapper">
  <div
    class="sidebar"
    data-color="blue"
    data-background-color="white"
    data-image="./assets/img/sidebar-1.jpg"
  >
    <app-sidebar-cmp></app-sidebar-cmp>
    <div
      class="sidebar-background"
      style="background-image: url(assets/img/sidebar-4.jpg)"
    ></div>
  </div>
  <div
    class="main-panel"
    style="background-image: url(./assets/img/fondoMain.jpg)"
  >
    <app-navbar-cmp></app-navbar-cmp>
    <router-outlet></router-outlet>
    <div *ngIf="!isMap()">
      <app-footer-cmp></app-footer-cmp>
    </div>
  </div>
</div>
<app-spinner></app-spinner>
